import { dew as _index3Dew } from "../validators/generated/index.js";
import { dew as _index4Dew } from "../builders/generated/index.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toComputedKey;
  var _index = _index3Dew();
  var _index2 = _index4Dew();
  function toComputedKey(node, key = node.key || node.property) {
    if (!node.computed && (0, _index.isIdentifier)(key)) key = (0, _index2.stringLiteral)(key.name);
    return key;
  }

  //# sourceMappingURL=toComputedKey.js.map
  return exports;
}